export const authorImage = () => ({
    width: '3.125rem',
    height: '3.125rem',
    overflow: 'hidden',
    marginRight: '1.125rem',
    display: 'inline-block',
});
